import React, { useCallback } from 'react';
import { Config } from '@leverege/plugin';
import { Geocoder } from '@leverege/ui-geo-elements';
import { Attributes, EditorUtil } from '@leverege/ui-attributes';
import { jsx as _jsx } from "react/jsx-runtime";
const opts = {
  table: {
    isRenderer: false,
    embed: true
  },
  detail: {
    isRenderer: false,
    embed: true
  }
};
function AddressEditor(props) {
  const {
    value,
    eventData,
    onChange: pOnChange,
    attribute,
    object,
    usage
  } = props;
  const simpleAddress = attribute?.blueprint?.attribute.getTagStartingWith('addressEditor:', true) === 'useSimpleAddress';
  const onChange = useCallback(async ({
    data,
    value
  }) => {
    const positionAttrName = attribute?.blueprint?.attribute?.getTagStartingWith('addressEditorPositionAttribute:', true) || 'geoPosition';
    const positionAttr = Attributes.getAttribute(positionAttrName, object.type);
    const change = {
      data: {
        [attribute.name]: attribute.name
      },
      value: {
        [attribute.name]: simpleAddress ? value.properties?.address : value.properties?.full_address
      }
    };
    if (positionAttr) {
      change.data[positionAttr.name] = positionAttr.name;
      change.value[positionAttr.name] = value.position;
    }
    await pOnChange(change);
  }, [pOnChange, attribute, object?.type, simpleAddress]);
  return /*#__PURE__*/_jsx(Geocoder, {
    inputVariant: EditorUtil.getVariant(usage, 'address', 'editor'),
    useUserLocation: true,
    onChange: onChange,
    eventData: eventData,
    value: value
  });
}
export default {
  createFor(name, objectType, {
    molten
  }) {
    molten.addPlugin('AttributeValueEditor', {
      name,
      objectType,
      getOptions(usage) {
        return Config.get('AddressEditor', usage, opts[usage]);
      },
      create(opts) {
        return /*#__PURE__*/_jsx(AddressEditor, {
          ...opts
        });
      }
    });
  }
};